import * as Actions from "../redux/practiceSession";
import * as AdminSessionActions from "../redux/adminSession";
import * as OmniDataAPI from "../../data/omniDataAPI";

import { call, put, select, takeLatest } from "redux-saga/effects";

import { isValidUUID } from "../../utils/helpers";
import { v4 as uuid } from "uuid";

// import * as OmniDemoData from "../../data/omniDemoData";

export function* updatePractice({ payload }) {
  try {
    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newPractice = yield call(OmniDataAPI.createPractice, payload);
      if (newPractice == null) {
        yield put(Actions.practiceSessionRequestFail("OmniDataAPI.createPractice FAILED"));
      } else {
        yield put(Actions.setPracticeODMRequest(newPractice));
        yield put(Actions.updatePracticeSuccess());
        yield put(AdminSessionActions.reflectUpdatedPracticeODMRequest(newPractice));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newPractice = yield call(OmniDataAPI.updatePractice, payload);
      if (newPractice == null) {
        yield put(Actions.practiceSessionRequestFail("OmniDataAPI.createPractice FAILED"));
      } else {
        yield put(Actions.setPracticeODMRequest(newPractice));
        yield put(Actions.updatePracticeSuccess());
        yield put(AdminSessionActions.reflectUpdatedPracticeODMRequest(newPractice));
      }
    } else {
      yield put(Actions.practiceSessionRequestFail("updatePractice: bad payload"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* deletePractice({ payload }) {
  try {
    //payload is UUID
    if (isValidUUID(payload)) {
      const practice = yield select(Actions.practiceODMSelector);
      let deletedPracctice = yield call(OmniDataAPI.deletePractice, payload);
      if (deletedPracctice != null) {
        yield put(Actions.deletePracticeSuccess(practice));
        //this method assumes that an ID alone is a delete
        yield put(AdminSessionActions.reflectUpdatedPracticeODMRequest(practice));
      }
    }
    const practiceODM = yield select(Actions.practiceODMSelector);
    if (practiceODM != null && payload === practiceODM._id) {
      yield put(Actions.setPracticeODMRequest(null));
    } else {
      yield put(Actions.practiceSessionRequestFail("deletePractice: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* loadPracticeODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setPracticeODMRequest(null));
    if (isValidUUID(payload)) {
      //PAYLOAD is a valid UUID
      let practiceODM = yield call(OmniDataAPI.getPractice, payload);
      yield put(Actions.setPracticeODMRequest(practiceODM));
      yield put(Actions.loadPracticeODMSuccess());
    } else {
      yield put(Actions.practiceSessionRequestFail("Bad Practice _id"));
      // //TODO depricate this block, no
      // //This is the case where we are using a demo Patient
      // console.log("attempting to set a demo practice");

      // let practiceODM = OmniDataModel.validatePracticeODM(OmniDemoData.getDemoPracticeODM(payload));
      // practiceODM._id = payload;

      // yield put(Actions.loadPracticeODMSuccess(practiceODM));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* setPracticeODM({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setPracticeODMSuccess(payload));
    //Do all ancillary data loads here
    yield put(Actions.loadRelatedPatientsRequest(payload));
    yield put(Actions.loadRelatedPartnersRequest(payload));
    yield put(Actions.loadRelatedProvidersRequest(payload));
    yield put(Actions.loadRelatedConversationConfigurationsRequest(payload));
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* loadRelatedPatients({ payload }) {
  try {
    //TODO adjust this call to pass params to query for the current practice

    // theReturn = theReturn.filter(obj => obj.omniData.patientData != null);
    //#region REFACTOR and DELETE
    // let patientODM = OmniDemoData.getDemoPatientODM("linda1");
    // patientODM._id = "linda1";
    // theReturn.push(patientODM);

    // patientODM = OmniDemoData.getDemoPatientODM("linda2");
    // patientODM._id = "linda2";
    // theReturn.push(patientODM);

    // patientODM = OmniDemoData.getDemoPatientODM("linda3");
    // patientODM._id = "linda3";
    // theReturn.push(patientODM);

    // patientODM = OmniDemoData.getDemoPatientODM("mae1");
    // patientODM._id = "mae1";
    // theReturn.push(patientODM);
    //#endregion

    // const practiceODM = yield select(Actions.practiceODMSelector);
    if (payload != null) {
      let theReturn = yield call(OmniDataAPI.getAllPatientsByRelatedId, payload._id);

      yield put(Actions.loadRelatedPatientsSuccess(theReturn));
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* updatePracticePatient({ payload }) {
  try {
    const practiceODM = yield select(Actions.practiceODMSelector);
    if (practiceODM != null) {
      const currentList = yield select(Actions.relatedPatientODMsSelector);

      //payload is no longer in the newList
      if (payload._id == null) {
        //CREATE
        payload._id = uuid();

        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];
        let newUser = yield call(OmniDataAPI.createPatient, payload);

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
          newList.push(newUser);
          yield put(Actions.updatePracticePatientSuccess(newList));
        } else {
          yield put(Actions.practiceSessionRequestFail("Failed to updatePracticePatient"));
        }
      } else if (isValidUUID(payload._id)) {
        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];

        //UPDATE
        let newUser = yield call(OmniDataAPI.updatePatient, payload);

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
          newList.push(newUser);
          yield put(Actions.updatePracticePatientSuccess(newList));
        } else {
          yield put(Actions.practiceSessionRequestFail("Failed to updatePracticePatient"));
        }
      } else {
        //DEMO TODO Remove this case
        //bad data
        // yield put(Actions.practiceSessionRequestFail("invalid _ID"));
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
        newList.push(payload);
        yield put(Actions.updatePracticePatientSuccess(newList));
      }
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* deletePracticePatient({ payload }) {
  try {
    const currentList = yield select(Actions.relatedPatientODMsSelector);
    const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload);

    //payload is no longer in the newList
    if (true) {
      if (isValidUUID(payload)) {
        //TODO validate this stuff
        yield call(OmniDataAPI.deletePatient, payload);
      }
    }

    yield put(Actions.deletePracticePatientSuccess(newList));
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

/////////////////////////////////////////////////////

export function* loadRelatedPartners({ payload }) {
  try {
    if (payload != null) {
      let theReturn = yield call(OmniDataAPI.getAllPartners, payload._id);
      yield put(Actions.loadRelatedPartnersSuccess(theReturn));
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* updatePracticePartner({ payload }) {
  try {
    const practiceODM = yield select(Actions.practiceODMSelector);
    if (practiceODM != null) {
      const currentList = yield select(Actions.relatedPartnerODMsSelector);

      //payload is no longer in the newList
      if (payload._id == null) {
        //CREATE
        payload._id = uuid();

        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];

        let newUser = yield call(OmniDataAPI.createPartner, payload);

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
          newList.push(newUser);
          yield put(Actions.updatePracticePartnerSuccess(newList));
        } else {
          yield put(Actions.practiceSessionRequestFail("Failed to updatePracticePartner"));
        }
      } else if (isValidUUID(payload._id)) {
        //UPDATE
        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];

        let newUser = yield call(OmniDataAPI.updatePartner, payload);

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
          newList.push(newUser);
          yield put(Actions.updatePracticePartnerSuccess(newList));
        } else {
          yield put(Actions.practiceSessionRequestFail("Failed to updatePracticePartner"));
        }
      } else {
        //bad data
        yield put(Actions.practiceSessionRequestFail("invalid _ID"));
      }
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* deletePracticePartner({ payload }) {
  try {
    const currentList = yield select(Actions.relatedPartnerODMsSelector);
    const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload);

    //payload is no longer in the newList
    if (true) {
      if (isValidUUID(payload)) {
        //TODO validate this stuff
        yield call(OmniDataAPI.deletePartner, payload);
      }
    }

    yield put(Actions.deletePracticePartnerSuccess(newList));
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

///////////////////////////////////////////////////////////////////

export function* loadRelatedProviders({ payload }) {
  try {
    if (payload != null) {
      let theReturn = yield call(OmniDataAPI.getAllProviders, payload._id);
      yield put(Actions.loadRelatedProvidersSuccess(theReturn));
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* updatePracticeProvider({ payload }) {
  try {
    const practiceODM = yield select(Actions.practiceODMSelector);
    if (practiceODM != null) {
      const currentList = yield select(Actions.relatedProviderODMsSelector);

      //payload is no longer in the newList
      if (payload._id == null) {
        //CREATE
        payload._id = uuid();

        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];

        let newUser = yield call(OmniDataAPI.createProvider, payload);

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);

          newList.push(newUser);
          yield put(Actions.updatePracticeProviderSuccess(newList));
        }
      } else if (isValidUUID(payload._id)) {
        //UPDATE
        let newUser = yield call(OmniDataAPI.updateProvider, payload);

        //TODO Update This when there are multiple Practices Supported
        // payload.omniRelationships.practices = [
        //   { practiceId: practiceODM._id, practiceType: "primary", practiceNote: "Set by Redux" },
        // ];

        if (newUser != null) {
          const newList =
            currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
          newList.push(newUser);
          yield put(Actions.updatePracticeProviderSuccess(newList));
        }
      } else {
        // bad data
        yield put(Actions.practiceSessionRequestFail("invalid _ID"));
      }
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* deletePracticeProvider({ payload }) {
  try {
    const currentList = yield select(Actions.relatedProviderODMsSelector);
    const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload);

    //payload is no longer in the newList
    if (true) {
      if (isValidUUID(payload)) {
        //TODO validate this stuff
        yield call(OmniDataAPI.deleteProvider, payload);
      }
    }

    yield put(Actions.deletePracticeProviderSuccess(newList));
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

//#region ConversationConfiguration

export function* loadRelatedConversationConfigurations({ payload }) {
  try {
    if (payload != null) {
      let theReturn = [];

      // for (
      //   let index = 0;
      //   index < payload.omniRelationships.conversationConfigurations.length;
      //   index++
      // ) {
      // let aReturn = yield call(
      //   OmniDataAPI.getConversationConfiguration,
      //   payload.omniRelationships.conversationConfigurations[index]
      // );
      //   if (aReturn != null) {
      //     theReturn.push(aReturn);
      //   }
      // }
      for (const aGuid of payload.omniRelationships.conversationConfigurations) {
        let aReturn = yield call(OmniDataAPI.getConversationConfiguration, aGuid);

        if (aReturn != null) {
          theReturn.push(aReturn);
        }
      }

      yield put(Actions.loadRelatedConversationConfigurationsSuccess(theReturn));
    } else {
      yield put(Actions.practiceSessionRequestFail("Current Practice is NULL"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* associateConversationConfigurations({ payload }) {
  try {
    const practiceODM = yield select(Actions.practiceODMSelector);
    if (practiceODM != null) {
      practiceODM.omniRelationships.conversationConfigurations = payload;
      yield put(Actions.updatePracticeRequest(practiceODM));
      yield put(Actions.associateConversationConfigurationsSuccess());
    } else {
      yield put(Actions.practiceSessionRequestFail("Practice is Null"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

export function* removeConversationConfiguration({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const practiceODM = yield select(Actions.practiceODMSelector);
      if (practiceODM != null) {
        const newList = practiceODM.omniRelationships.conversationConfigurations.filter(
          obj => obj._id !== payload
        );

        practiceODM.omniRelationships.conversationConfigurations = newList;
        yield put(Actions.updatePracticeRequest(practiceODM));

        yield put(Actions.removeConversationConfigurationSuccess());
      } else {
        yield put(Actions.practiceSessionRequestFail("Practice is Null"));
      }
    } else {
      yield put(Actions.practiceSessionRequestFail("Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.practiceSessionRequestFail(error));
  }
}

//#endregion

//  saga
export default function* practiceDataSaga() {
  yield takeLatest(Actions.updatePracticeRequest, updatePractice);
  yield takeLatest(Actions.deletePracticeRequest, deletePractice);
  yield takeLatest(Actions.loadPracticeODMRequest, loadPracticeODM);
  yield takeLatest(Actions.setPracticeODMRequest, setPracticeODM);

  yield takeLatest(Actions.loadRelatedPatientsRequest, loadRelatedPatients);
  yield takeLatest(Actions.updatePracticePatientRequest, updatePracticePatient);
  yield takeLatest(Actions.deletePracticePatientRequest, deletePracticePatient);

  yield takeLatest(Actions.loadRelatedPartnersRequest, loadRelatedPartners);
  yield takeLatest(Actions.updatePracticePartnerRequest, updatePracticePartner);
  yield takeLatest(Actions.deletePracticePartnerRequest, deletePracticePartner);

  yield takeLatest(Actions.loadRelatedProvidersRequest, loadRelatedProviders);
  yield takeLatest(Actions.updatePracticeProviderRequest, updatePracticeProvider);
  yield takeLatest(Actions.deletePracticeProviderRequest, deletePracticeProvider);

  yield takeLatest(
    Actions.loadRelatedConversationConfigurationsRequest,
    loadRelatedConversationConfigurations
  );
  yield takeLatest(
    Actions.associateConversationConfigurationsRequest,
    associateConversationConfigurations
  );
  yield takeLatest(Actions.removeConversationConfigurationRequest, removeConversationConfiguration);
}
